import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { OperationCriteriaModel } from '@models/operation.model';
import { CurrentUserService } from '@core/services/currentUser.service';
import {
  GET_OPERATION,
  GET_OPERATIONS,
  GET_OPERATION_STATUS,
} from '../graphql/operation.GraphQL';
import { GET_SERVICES } from '../graphql/service.graphql';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OperationResolver  {
  constructor(private apollo: Apollo, public router: Router) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.apollo.query({
      query: GET_OPERATION,
      variables: {
        id: route.paramMap.get('id'),
      },
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class OperationListResolver  {
  constructor(
    private apollo: Apollo,
    private currentUser: CurrentUserService
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.apollo.query({
      query: GET_OPERATIONS,
      variables: {
        criteria: new OperationCriteriaModel(
          route.queryParamMap.get('tenant')!,
          this.currentUser.currentUser.collectorIds
        ),
      },
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class OperationStatusListResolver  {
  constructor(private apollo: Apollo) {}

  resolve() {
    return this.apollo.query({
      query: GET_OPERATION_STATUS,
    });
  }
}


@Injectable({
  providedIn: 'root',
})
export class ServiceListResolver  {
  constructor(private apollo: Apollo, public router: Router) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.apollo.query({
      query: GET_SERVICES,
      variables: {
        tenantId:  route.queryParamMap.get('tenant')!,

      }
    }).pipe(map((val: any) => val.data.searchServices));
  }
}
